import { useEffect, useRef, useState, type CSSProperties } from 'react';
import { SlideRenderer, type Theme } from '@/cowork/omniad/components/slides/SlideRenderer';

type Slide = Record<string, any>;

/**
 * A miniature of a slide. The slide is laid out at a fixed 960×540 and scaled down with a transform:
 * rendering it directly at thumbnail size lets Chrome's minimum font size inflate the small text
 * (cqw units below ~6px get clamped), which made the previews look different from the real pages.
 */
export function SlideThumb({ slide, index, theme, title, radius = 0 }: { slide: Slide; index: number; theme: Theme; title: string; radius?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const ro = new ResizeObserver((entries) => setW(entries[0]?.contentRect.width || 0));
    ro.observe(el); setW(el.clientWidth);
    return () => ro.disconnect();
  }, []);
  const W = 960; const H = 540; const scale = w ? w / W : 0;
  return (
    <div ref={ref} style={{ position: 'relative', aspectRatio: '16 / 9', background: theme.bg, pointerEvents: 'none', overflow: 'hidden', borderRadius: radius }}>
      {scale > 0 && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: W, height: H, transform: `scale(${scale})`, transformOrigin: 'top left', containerType: 'size' } as CSSProperties}>
          <SlideRenderer slide={slide} index={index} theme={theme} title={title} />
        </div>
      )}
    </div>
  );
}
